import { ConfirmationDialog } from '@/components/Common/ConfirmationDialog/ConfirmationDialog';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { CartItemUi } from '../CartUi';
import { useContextualMenuViewController } from './ContextualMenuViewController';

export function ContextualMenu(props: { order: CartItemUi }) {
  const { order } = props;
  const { uiState, actions, references } = useContextualMenuViewController({
    order,
  });

  return (
    <Box>
      <IconButton onClick={actions.handleClickOpenMenu} sx={{ padding: '0px' }}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={references.anchorEl.current}
        open={uiState.open}
        onClose={actions.handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {uiState.showView && (
          <MenuItem onClick={actions.onClickedViewCart}>Ver</MenuItem>
        )}
        <MenuItem onClick={actions.onClickedDuplicateCart}>Duplicar</MenuItem>
        <MenuItem onClick={actions.onClickedDeleteCart}>Borrar</MenuItem>
        {uiState.showEdit && (
          <MenuItem onClick={actions.onClickedEditCart}>Editar</MenuItem>
        )}
      </Menu>

      <ConfirmationDialog
        open={uiState.showDeleteDialog}
        title="Confirmar eliminación"
        message="¿Estás seguro de que deseas eliminar este carrito?"
        okButton={{ label: 'Eliminar', variant: 'contained' }}
        onOkButtonListener={actions.handleConfirmDelete}
        koButton={{ label: 'Cancelar', variant: 'outlined' }}
        onKoButtonListener={() => actions.handleCancelDeleteDialog()}
      />

      <ConfirmationDialog
        open={uiState.showDuplicateDialog}
        title="Confirmar Duplicado"
        message="¿Estás seguro de que deseas duplicar este carrito?"
        okButton={{ label: 'Duplicar', variant: 'contained' }}
        onOkButtonListener={actions.handleConfirmDuplicate}
        koButton={{ label: 'Cancelar', variant: 'outlined' }}
        onKoButtonListener={() => actions.handleCancelDuplicateDialog()}
        cancelable
      />
    </Box>
  );
}
